var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0193356 14.9385C0.0193356 13.8757 0.0363635 12.813 0.0534704 11.7453C0.0621433 11.204 0.0708364 10.6615 0.0773413 10.117C0.0773413 4.26713 4.94985 0.00195312 11.6785 0.00195312H20.3214C27.0501 0.00195312 31.9227 4.26713 31.9227 10.117C31.9807 12.4603 32 14.8036 32 17.1638C32 19.524 31.9807 21.901 31.9227 24.2443C31.9227 30.0942 27.0501 34.3594 20.3214 34.3594H11.6785C4.94985 34.3594 0.0773413 30.0942 0.0773413 24.2275C0.0386706 22.019 0 19.76 0 17.4673L0.0193356 14.9385ZM18.9272 30.3063V30.5811C18.9272 31.7383 17.6399 32.6426 16.0015 32.6426C14.4021 32.6426 13.0758 31.7383 13.0758 30.5811V30.3063C13.0758 29.1794 14.4021 28.2448 16.0015 28.2448C17.6399 28.2448 18.9272 29.1794 18.9272 30.3063ZM4.60638 11.0707C4.59416 11.7647 4.58199 12.4555 4.58199 13.1463L4.56818 14.7899C4.56818 16.2802 4.5958 17.7486 4.62343 19.1841C4.62343 22.9975 8.10379 25.7698 12.91 25.7698H19.0835C23.8897 25.7698 27.3701 22.9975 27.3701 19.1951C27.4115 17.6719 27.4253 16.1268 27.4253 14.5927C27.4253 13.0586 27.4115 11.5354 27.3701 10.0123C27.3701 6.20986 23.8897 3.4375 19.0835 3.4375H12.91C8.10379 3.4375 4.62343 6.20986 4.62343 10.0123C4.61878 10.3662 4.61257 10.7188 4.60638 11.0707Z",
    fill: "#1D619D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.56f16bf2529abb6c91d0aaae5e564f07.svg";
export { ForwardRef as ReactComponent };